import { MenuDivider, type MenuDividerProps } from '@chakra-ui/react';

export type UiMenuDividerProps = MenuDividerProps;

export const UiMenuDivider = MenuDivider;
